import createSingle from "./create-single.js";
import validatePermissions from "./validate-permissions.js";
import getSingle from "./get-single.js";
import getMultiple from "./get-multiple.js";
import deleteSingle from "./delete-single.js";
import updateSingle from "./update-single.js";

export default {
	createSingle,
	validatePermissions,
	getSingle,
	getMultiple,
	deleteSingle,
	updateSingle,
};
